import {Injectable} from '@angular/core';
import {CanLoad, Route, Router, UrlSegment, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {DeviceDetectorService} from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorGuard implements CanLoad {

  deviceInfo = null; 

  constructor(private deviceService: DeviceDetectorService, private router: Router) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    const isDesktopDevice = this.deviceService.isDesktop();

    console.log(this.router.url);
    console.log(isDesktopDevice);
    if (!isDesktopDevice) {
      if (this.router.url !== '/') {
        this.router.navigate(['/auth/finger', { login: true }]).then();
      }
    }
    return true;
  }
}
